import React from "react";
import "./navbarPopup.css";

const InvitesPop = () => {
  return (
    <div className="navbar__popup w-2/4 pr-10 pl-10 pb-10 rounded-md bg-white shadow-md">
      <div className="popup__container">
        <div className="venuelist flex justify-between mt-5">
          <div className="venuelist__items">
            <div className="photographer">
              <span className="photographer__title text-textPrimary-900 font-semibold">
                Photographers
              </span>
              {/* First List Item */}
              <ul className="mt-1">
                <li>
                  <a href="*">Photographer One</a>
                </li>
                <li>
                  <a href="*">Photographer Two</a>
                </li>
                <li>
                  <a href="*">Photographer Three</a>
                </li>
                <li>
                  <a href="*">Photographer Four</a>
                </li>
                <li>
                  <a href="*">Photographer Five</a>
                </li>
              </ul>
            </div>

            {/* Second List Item */}
            <div className="makeup mt-3">
              <span className="makeup__title text-textPrimary-900 font-semibold">
                Makeup
              </span>
              {/* First List Item */}
              <ul>
                <li>
                  <a href="*">Makeup One</a>
                </li>
                <li>
                  <a href="*">Makeup Two</a>
                </li>
              </ul>
            </div>

            {/* Third List Item */}
            <div className="bridal mt-3">
              <span className="bridal__title text-textPrimary-900 font-semibold">
                Bridal Wear
              </span>
              {/* First List Item */}
              <ul>
                <li>
                  <a href="*">Bridal One</a>
                </li>
                <li>
                  <a href="*">Bridal Two</a>
                </li>
                <li>
                  <a href="*">Bridal Three</a>
                </li>
                <li>
                  <a href="*">Bridal Four</a>
                </li>
                <li>
                  <a href="*">Bridal Five</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="venuelist__items">
            <div className="photographer">
              <span className="photographer__title text-textPrimary-900 font-semibold">
                Photographers
              </span>
              {/* First List Item */}
              <ul className="mt-1">
                <li>
                  <a href="*">Photographer One</a>
                </li>
                <li>
                  <a href="*">Photographer Two</a>
                </li>
                <li>
                  <a href="*">Photographer Three</a>
                </li>
                <li>
                  <a href="*">Photographer Four</a>
                </li>
                <li>
                  <a href="*">Photographer Five</a>
                </li>
              </ul>
            </div>

            {/* Second List Item */}
            <div className="makeup mt-3">
              <span className="makeup__title text-textPrimary-900 font-semibold">
                Makeup
              </span>
              {/* First List Item */}
              <ul>
                <li>
                  <a href="*">Makeup One</a>
                </li>
                <li>
                  <a href="*">Makeup Two</a>
                </li>
              </ul>
            </div>

            {/* Third List Item */}
            <div className="bridal mt-3">
              <span className="bridal__title text-textPrimary-900 font-semibold">
                Bridal Wear
              </span>
              {/* First List Item */}
              <ul>
                <li>
                  <a href="*">Bridal One</a>
                </li>
                <li>
                  <a href="*">Bridal Two</a>
                </li>
                <li>
                  <a href="*">Bridal Three</a>
                </li>
                <li>
                  <a href="*">Bridal Four</a>
                </li>
                <li>
                  <a href="*">Bridal Five</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="venuelist__items">
            <div className="photographer">
              <span className="photographer__title text-textPrimary-900 font-semibold">
                Photographers
              </span>
              {/* First List Item */}
              <ul className="mt-1">
                <li>
                  <a href="*">Photographer One</a>
                </li>
                <li>
                  <a href="*">Photographer Two</a>
                </li>
                <li>
                  <a href="*">Photographer Three</a>
                </li>
                <li>
                  <a href="*">Photographer Four</a>
                </li>
                <li>
                  <a href="*">Photographer Five</a>
                </li>
              </ul>
            </div>

            {/* Second List Item */}
            <div className="makeup mt-3">
              <span className="makeup__title text-textPrimary-900 font-semibold">
                Makeup
              </span>
              {/* First List Item */}
              <ul>
                <li>
                  <a href="*">Makeup One</a>
                </li>
                <li>
                  <a href="*">Makeup Two</a>
                </li>
              </ul>
            </div>

            {/* Third List Item */}
            <div className="bridal mt-3">
              <span className="bridal__title text-textPrimary-900 font-semibold">
                Bridal Wear
              </span>
              {/* First List Item */}
              <ul>
                <li>
                  <a href="*">Bridal One</a>
                </li>
                <li>
                  <a href="*">Bridal Two</a>
                </li>
                <li>
                  <a href="*">Bridal Three</a>
                </li>
                <li>
                  <a href="*">Bridal Four</a>
                </li>
                <li>
                  <a href="*">Bridal Five</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="venuelist__items">
            <div className="photographer">
              <span className="photographer__title text-textPrimary-900 font-semibold">
                Photographers
              </span>
              {/* First List Item */}
              <ul className="mt-1">
                <li>
                  <a href="*">Photographer One</a>
                </li>
                <li>
                  <a href="*">Photographer Two</a>
                </li>
                <li>
                  <a href="*">Photographer Three</a>
                </li>
                <li>
                  <a href="*">Photographer Four</a>
                </li>
                <li>
                  <a href="*">Photographer Five</a>
                </li>
              </ul>
            </div>

            {/* Second List Item */}
            <div className="makeup mt-3">
              <span className="makeup__title text-textPrimary-900 font-semibold">
                Makeup
              </span>
              {/* First List Item */}
              <ul>
                <li>
                  <a href="*">Makeup One</a>
                </li>
                <li>
                  <a href="*">Makeup Two</a>
                </li>
              </ul>
            </div>

            {/* Third List Item */}
            <div className="bridal mt-3">
              <span className="bridal__title text-textPrimary-900 font-semibold">
                Bridal Wear
              </span>
              {/* First List Item */}
              <ul>
                <li>
                  <a href="*">Bridal One</a>
                </li>
                <li>
                  <a href="*">Bridal Two</a>
                </li>
                <li>
                  <a href="*">Bridal Three</a>
                </li>
                <li>
                  <a href="*">Bridal Four</a>
                </li>
                <li>
                  <a href="*">Bridal Five</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvitesPop;
